import { Component, OnInit } from '@angular/core';
import { AccommodationsService } from '../accommodations.service';

@Component({
	selector: 'app-accommodations-products-select',
	templateUrl: './accommodations-products-select.component.html',
	styleUrls: ['./accommodations-products-select.component.scss'],
})
export class AccommodationsProductsSelectComponent implements OnInit {
	protected products = [];
	protected selected = [];

	constructor(public service: AccommodationsService) {}

	ngOnInit(): void {
		this.products = [...this.service.data.products];
		this.selected = [...this.service.selected.getValue().products];
	}

	protected applyfilter(filterValue: string): void {
		this.products = this.service.filterBy(this.service.data.products, filterValue, 'name');
	}

	protected change(product) {
		const index = this.selected.indexOf(product.id);
		if (index == -1) {
			this.selected.push(product.id);
			return;
		}
		this.selected.splice(index, 1);
	}

	protected selectAll(): void {
		this.products.forEach((product) => {
			if (this.selected.indexOf(product.id) == -1) {
				this.selected.push(product.id);
			}
		});
	}

	protected clear(): void {
		this.selected = [];
	}
}
